// extracted by mini-css-extract-plugin
export default {"btn":"SliderButton_btn__IWend","small":"SliderButton_small__t+kGb","prev":"SliderButton_prev__9r+39","next":"SliderButton_next__pIufr","large":"SliderButton_large__iNmMg"};